// extracted by mini-css-extract-plugin
export default {"offerContainer":"Contacts_offerContainer__R08uu"};